import { createAppRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';
import type {
  FamsOperationsOverviewHoldingDetailQueryParams,
  FamsOperationsOverviewHoldingDetailResponse,
  FamsOperationsOverviewQueryParams,
  FamsOperationsOverviewResponse,
} from './types/operations-overview';

const request = createAppRequest();

export async function getFamsOperationsOverview(
  params?: FamsOperationsOverviewQueryParams,
  options?: ApiRequestOptions,
) {
  return request<FamsOperationsOverviewResponse>('/bff/fams/operations-overview', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

export async function getFamsOperationsOverviewHoldingDetail(
  params?: FamsOperationsOverviewHoldingDetailQueryParams,
  options?: ApiRequestOptions,
) {
  return request<FamsOperationsOverviewHoldingDetailResponse>(
    '/bff/fams/operations-overview/holding-structure-detail',
    {
      method: 'GET',
      params,
      ...(options || {}),
    },
  );
}
